var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-row license-row" },
    _vm._l(_vm.versionedLicenses, function(license) {
      return _c(
        "LicenceItem",
        {
          key: license.code,
          staticClass: "flex-fill-column ov-reset wp-3",
          attrs: {
            title: license.label,
            code: license.code,
            total: _vm.getTotal(license.code),
            value: _vm.getValue(license.code),
            enableSupport: _vm.enableSupport,
            disable: !_vm.isEnable(license.code)
          }
        },
        [
          _vm._v(
            "\n        " + _vm._s(_vm.$l10n.__(license.description)) + "\n    "
          )
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }